import cpEmpty from './empty'
import cpPageOut from './page-out'
import cpPageScroll from './page-scroll'
import cpPageRefresh from './page-refresh'

export default {
  install: function (Vue) {
    // 注册并获取组件，然后在main.js中引用，在Vue.use()就可以了
    Vue.component('cp-empty', cpEmpty) // 数据空
    Vue.component('cp-page-out', cpPageOut) // 页面错误
    Vue.component('cp-page-scroll', cpPageScroll) // 列表加载
    Vue.component('cp-page-refresh', cpPageRefresh) // 页面刷新
  }
}
